type FlightPathProps = {
  className?: string;
  label?: string;
};

export default function FlightPath({ className = "", label }: FlightPathProps) {
  return (
    <svg
      className={`flight-path-mark ${className}`.trim()}
      viewBox="0 0 240 92"
      fill="none"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <path
        d="M12 69C57 83 62 20 116 29C158 36 162 68 215 23"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="1 8"
      />
      <circle cx="12" cy="69" r="5" fill="currentColor" />
      <circle cx="215" cy="23" r="7" stroke="currentColor" strokeWidth="2" />
      <circle cx="215" cy="23" r="2.5" fill="currentColor" />
      <path
        className="flight-path-plane"
        d="m218 18 11-8-2 12-4-3-4 4 1-5-2 0Z"
        fill="currentColor"
      />
    </svg>
  );
}
